import { Navigate, useParams } from 'react-router-dom';

/** Bestandslinks auf `/customers/:id` zeigen weiterhin auf den Geschäftspartner. */
export function LegacyCustomerRedirect(): JSX.Element {
  const params = useParams<{ id: string }>();
  return <Navigate to={`/partners/${params.id ?? ''}`} replace />;
}
